import { createThemeWithPalettes } from 'theme';
import domains from 'libs/domain/domains';
import { DomainConfig, ThemedDomainConfig } from '../config';

const defaultDomain = domains[0];

export type DomainCheck = (
  location: string,
  enabledKeys: string[]
) => string | undefined;

const domainToEntryKey: DomainCheck = (location: string, enabledKeys) => {
  // remove protocol from the location
  const locationWithoutProtocol = location.replace(/^[a-zA-Z]+:\/\//, '');
  const key = domains.find((item) =>
    locationWithoutProtocol.startsWith(item.key)
  )?.key;
  return key && enabledKeys.includes(key) ? key : undefined;
};

export const domainToThemedDomain = (
  config: DomainConfig
): ThemedDomainConfig => {
  return {
    ...config,
    isDefaultDomain: config.key === 'DEFAULT',
    themes: createThemeWithPalettes(
      config.palettes.lightPalette,
      config.palettes.darkPalette
    ),
  };
};

export const resolveDomain = (
  commaSeparatedDomainKeys: string,
  domainCheck: DomainCheck = domainToEntryKey
): ThemedDomainConfig => {
  const enabledDomainKeys = commaSeparatedDomainKeys
    .split(',')
    .filter((split) => split.trim().length > 0);

  if (enabledDomainKeys.length === 0)
    return domainToThemedDomain(defaultDomain);

  const domainKey = domainCheck(window.location.href, enabledDomainKeys);
  const maybeDomain = domains.find((item) => item.key === domainKey);

  return domainToThemedDomain(maybeDomain ?? defaultDomain);
};
